module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_05@3x-7830e67c1495e87988a4867a8d8be997.webp";